import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fdd73f9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0fdd73f9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd73f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd73f9')) {
      api.createRecord('0fdd73f9', component.options)
    } else {
      api.reload('0fdd73f9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fdd73f9&scoped=true", function () {
      api.rerender('0fdd73f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GeneralEditForm/index.vue"
export default component.exports